import { Unstable_Grid2 as Grid } from '@mui/material';

import { InfoField } from '@occc-app/design-system';

type LocationScanDataAltriaDetailsProps = {
  altriaMan: string | null;
  altriaRcn: string | null;
};

export const LocationScanDataAltriaDetails = (props: LocationScanDataAltriaDetailsProps) => {
  const { altriaMan, altriaRcn } = props;

  return (
    <Grid container spacing={2}>
      <Grid xs={3}>
        <InfoField label='Altria RCN' value={altriaRcn} />
      </Grid>
      <Grid xs={3}>
        <InfoField label='Altria MAN' value={altriaMan} />
      </Grid>
    </Grid>
  );
};
